// Seçenek listeleri ve yardımcılar: Çalışan Ekle / Düzenle pencereleri ve tablo.
// Kayıtlı değerler (value) Türkçe kalır; `key` geçerli dildeki adı bulur.
import { LANGUAGE_LEVEL_OPTIONS, LANGUAGE_OPTIONS } from '../../../constants/employeeOptions';

export const COMPANY_EMAIL_DOMAIN = 'habcarecro.com';

export const NATIONALITY_OPTIONS = [
  { value: 'Türk', key: 'turkish' },
  { value: 'Afganlı', key: 'afghan' },
  { value: 'Alman', key: 'german' },
  { value: 'Amerikalı', key: 'american' },
  { value: 'Arap', key: 'arab' },
  { value: 'Arnavut', key: 'albanian' },
  { value: 'Azeri', key: 'azerbaijani' },
  { value: 'Belçikalı', key: 'belgian' },
  { value: 'Boşnak', key: 'bosnian' },
  { value: 'Bulgar', key: 'bulgarian' },
  { value: 'Çinli', key: 'chinese' },
  { value: 'Fransız', key: 'french' },
  { value: 'Gürcü', key: 'georgian' },
  { value: 'Hintli', key: 'indian' },
  { value: 'Hollandalı', key: 'dutch' },
  { value: 'İngiliz', key: 'british' },
  { value: 'İranlı', key: 'iranian' },
  { value: 'İspanyol', key: 'spanish' },
  { value: 'İsveçli', key: 'swedish' },
  { value: 'İtalyan', key: 'italian' },
  { value: 'Japon', key: 'japanese' },
  { value: 'Kazak', key: 'kazakh' },
  { value: 'Kırgız', key: 'kyrgyz' },
  { value: 'Koreli', key: 'korean' },
  { value: 'Lübnanlı', key: 'lebanese' },
  { value: 'Makedon', key: 'macedonian' },
  { value: 'Mısırlı', key: 'egyptian' },
  { value: 'Moldovalı', key: 'moldovan' },
  { value: 'Özbek', key: 'uzbek' },
  { value: 'Pakistanlı', key: 'pakistani' },
  { value: 'Polonyalı', key: 'polish' },
  { value: 'Portekizli', key: 'portuguese' },
  { value: 'Romanyalı', key: 'romanian' },
  { value: 'Rus', key: 'russian' },
  { value: 'Sırp', key: 'serbian' },
  { value: 'Suriyeli', key: 'syrian' },
  { value: 'Tacik', key: 'tajik' },
  { value: 'Tunuslu', key: 'tunisian' },
  { value: 'Türkmen', key: 'turkmen' },
  { value: 'Ukraynalı', key: 'ukrainian' },
  { value: 'Ürdünlü', key: 'jordanian' },
  { value: 'Yunan', key: 'greek' },
  { value: 'Diğer', key: 'other' },
];

const LANGUAGE_KEYS = {
  'İngilizce': 'english',
  'Almanca': 'german',
  'Fransızca': 'french',
  'İspanyolca': 'spanish',
  'İtalyanca': 'italian',
  'Rusça': 'russian',
  'Arapça': 'arabic',
  'Farsça': 'persian',
  'Çince': 'chinese',
  'Japonca': 'japanese',
  'Korece': 'korean',
  'Portekizce': 'portuguese',
  'Hollandaca': 'dutch',
  'Yunanca': 'greek',
  'Azerice': 'azerbaijani',
  'Türkçe': 'turkish',
  'Diğer': 'other',
};

export { LANGUAGE_OPTIONS, LANGUAGE_LEVEL_OPTIONS };

/** Görünen uyruk adı; listede olmayan (eski) değerler olduğu gibi. */
export const nationalityLabel = (t, value) => {
  const option = NATIONALITY_OPTIONS.find((item) => item.value === value);
  return option ? t(`employees.nationalities.${option.key}`) : String(value);
};

/** Görünen dil adı. */
export const languageLabel = (t, value) =>
  (LANGUAGE_KEYS[value] ? t(`employees.languageNames.${LANGUAGE_KEYS[value]}`) : value);

/** Görünen dil seviyesi ("Ana Dil" çevrilir, A1…C2 aynı kalır). */
export const languageLevelLabel = (t, value) => (value === 'Ana Dil' ? t('employees.form.languages.native') : value);

// --- Şirket e-postası ---------------------------------------------------

const TURKISH_TO_ASCII = { ç: 'c', ğ: 'g', ı: 'i', ö: 'o', ş: 's', ü: 'u', Ç: 'c', Ğ: 'g', İ: 'i', Ö: 'o', Ş: 's', Ü: 'u' };

// Noktayla başlamayan/bitmeyen, art arda nokta içermeyen yerel kısım. Büyük
// harf kabul edilir: eski kayıtlarda olabilir (yeni girişler küçük harfe çevrilir).
const LOCAL_PART_PATTERN = /^[a-z0-9_%+-]+(\.[a-z0-9_%+-]+)*$/i;

export const isCompanyEmail = (email) =>
  typeof email === 'string' && email.trim().toLowerCase().endsWith(`@${COMPANY_EMAIL_DOMAIN}`);

export const localPartOf = (email) => String(email || '').split('@')[0];

/**
 * Kullanıcının yazdığı adres başı: yapıştırılan tam adreste @ sonrası atılır,
 * boşluklar silinir, Türkçe harfler İngilizce karşılıklarına çevrilir ve
 * küçük harfe dönülür (giriş sistemi adresleri küçük harfle tutar).
 */
export const normalizeLocalPart = (input) => {
  let value = String(input || '');
  if (value.includes('@')) value = value.slice(0, value.indexOf('@'));
  value = value.replace(/[çğıöşüÇĞİÖŞÜ]/g, (char) => TURKISH_TO_ASCII[char] || char);
  return value.replace(/\s+/g, '').toLowerCase();
};

export const isValidLocalPart = (local) => LOCAL_PART_PATTERN.test(local);

export const companyEmail = (local) => (local ? `${local}@${COMPANY_EMAIL_DOMAIN}` : '');

// --- Telefon (Yeni Çalışan formu) -----------------------------------------

// Phone input helpers: keep digits only and format as 5XX XXX XX XX
const normalizePhoneDigits = (input) => {
  const digits = (input || '').replace(/\D/g, '');
  // Optional: if starts with 0, drop it (e.g., 05xx -> 5xx)
  const normalized = digits.startsWith('0') ? digits.slice(1) : digits;
  // Limit to 10 digits total (Turkish mobile numbers without leading 0)
  return normalized.slice(0, 10);
};

const formatPhonePretty = (digits) => {
  // Expect up to 10 digits, shown as 5XX XXX XX XX
  if (!digits) return '';
  return [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 8), digits.slice(8, 10)].filter(Boolean).join(' ');
};

/** Typed or pasted phone number → "5XX XXX XX XX". */
export const formatPhoneInput = (raw) => formatPhonePretty(normalizePhoneDigits(raw));

// Same rule as the old form's pattern attribute
export const PHONE_PATTERN = /^[0-9 ]{10,13}$/;

// --- Dosyalar penceresi -----------------------------------------------------

// Dosya türleri (kayıtlı değer = value). "İşten Ayrılış Sözleşme" yüklendiğinde
// çıkış süreci başlar (bkz. utils/employeeExit EXIT_CONTRACT_CATEGORY).
export const FILE_CATEGORIES = [
  { value: 'Nüfuz Cüzdanı Fotokopisi', key: 'idCopy' },
  { value: 'İkametgah', key: 'residence' },
  { value: 'Adli Sicil Kaydı', key: 'criminalRecord' },
  { value: 'Sağlık Raporu', key: 'healthReport' },
  { value: 'Nüfuz Kayıt Örneği', key: 'registry' },
  { value: 'Aile Durumu Bildirimi', key: 'familyStatus' },
  { value: 'Lise Diploma', key: 'highSchool' },
  { value: 'Lisans Diploma', key: 'bachelor' },
  { value: 'Yüksek Lisans Diploma', key: 'master' },
  { value: 'Doktora Diploma', key: 'phd' },
  { value: 'SGK Giriş Bildirgesi', key: 'sgk' },
  { value: 'İşe Giriş Sözleşme', key: 'employmentContract' },
  { value: 'İşten Ayrılış Sözleşme', key: 'exitContract' },
  { value: 'Kan Kartı', key: 'bloodCard' },
  { value: 'Resim', key: 'photo' },
  { value: 'Sertifika', key: 'certificate' },
  { value: 'Ön Lisans Diploma', key: 'associate' },
  { value: 'Diğer', key: 'other' },
];

/** Görünen dosya türü adı; listede olmayan (eski) değerler olduğu gibi. */
export const fileCategoryLabel = (t, value) => {
  const category = FILE_CATEGORIES.find((item) => item.value === value);
  return category ? t(`employees.fileCategories.${category.key}`) : value;
};

// CV/GCP/IATA belge türleri (CVDocuments.documentType)
const CV_TYPE_KEYS = { 'CV-TR': 'cvTr', 'CV-EN': 'cvEn', GCP: 'gcp', IATA: 'iata' };

export const cvTypeLabel = (t, type, fallback) =>
  (CV_TYPE_KEYS[type] ? t(`employees.cvTypes.${CV_TYPE_KEYS[type]}`) : fallback || type);

// İzin türleri (LeaveRequests.leaveType)
const LEAVE_TYPES = ['yillik', 'mazeret', 'raporlu'];

export const leaveTypeLabel = (t, type) =>
  (LEAVE_TYPES.includes(type) ? t(`employees.modals.pendingLeaves.types.${type}`) : type);
